import { bb } from "$json";
/* popup-internal-links:
 *
 * Tag 'internal links' as liable to popping up.
 *
 * Provide defaults in conf.json: arbitrary['p-popup-links-props'];
 *
 * @dependencies: popup-links
 *
 * Author: Niels Giesen
 *
 * Copyright 2017 Berkeley Bridge
 *
 */
(function ($, win, doc) {
  var externalre = /^([a-zA-Z][a-zA-Z.+-]*:)?\/\//,
    internalre = "uniqueid=",
    defaults =
      (bb.conf.arbitrary && bb.conf.arbitrary["p-popup-links-props"]) || "";

  function fixIt(_, control) {
    if (control.controltype === "linklabel") {
      if (!control.url.match(externalre)) {
        if (control.url.match(internalre)) {
          if (!control.meta) control.meta = [];
          control.meta["p-popup-links"] = true;
          control.meta["p-popup-links-props"] =
            defaults || "width=400,height=600";
        }
      }
    } else if (control.controltype === "grid") {
      $.each(control.columns, function (i, column) {
        if (column.controltype === "linklabel") {
          $.each(control.value, function (ii, row) {
            if (row[i]) {
              row[i].controltype = "linklabel";
              fixIt(undefined, row[i]);
              delete row[i].controltype;
            }
          });
        }
      });
    }
  }

  $(function () {
    $(document).on("bb:preHandleData", function (event, data) {
      if (data && data.groups) {
        $.each(data.groups, function (i, group) {
          $.each(group.controls, fixIt);
        });
      }
    });
  });

  bb.popupInternalLinks = function (data) {
    if (data && data.groups) {
      $.each(data.groups, function (i, group) {
        $.each(group.controls, fixIt);
      });
    }
  };
})(jQuery, window, document);
